/** Normalize Polish/English enum values from Directus for filter matching. */
export const normalizeValue = (value) => {
  if (!value || typeof value !== 'string') return value;

  const normalized = value.toLowerCase().trim();

  const sentimentMap = {
    pozytywny: 'positive',
    negatywny: 'negative',
    neutralny: 'neutral'
  };

  const urgencyMap = {
    niski: 'low',
    niska: 'low',
    średni: 'medium',
    średnia: 'medium',
    wysoki: 'high',
    wysoka: 'high'
  };

  const resolutionMap = {
    rozwiązany: 'resolved',
    rozwiązane: 'resolved',
    nierozwiązany: 'unresolved',
    nierozwiązane: 'unresolved',
    częściowo_rozwiązany: 'partially_resolved',
    częściowo_rozwiązane: 'partially_resolved'
  };

  return sentimentMap[normalized] || urgencyMap[normalized] || resolutionMap[normalized] || value;
};
